import { ApiResponse } from '../../types';

const apiUrl: string = import.meta.env.VITE_ADMIN_URL;

export const crearPuesto = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body }),
    };

    fetch(
      apiUrl + "/puesto/crear",
      requestOptions
    )
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const obtenerPuestos = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body })
    };

    fetch(
      apiUrl + "/puesto/obtener",
      requestOptions
    )
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al obtener puestos: ", err);
        reject(err);
      });
  });
};

export const eliminarPuesto = (token: string, values: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...values }),
    };

    fetch(apiUrl + "/puesto/eliminar", requestOptions)
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al eliminar puesto: ", err);
        reject(err);
      });
  });
};

export const crearArea = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...body
      }),
    };

    fetch(apiUrl + "/puesto/area/crear", requestOptions)
    .then((res) => res.json())
    .then((data: ApiResponse) => {
      resolve(data);
    })
    .catch((err) => {
      reject(err);
    });
  });
};

export const eliminarArea = (token: string, values: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...values }),
    };

    fetch(apiUrl + "/puesto/area/eliminar", requestOptions)
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al eliminar área: ", err);
        reject(err);
      });
  });
};

export const agregarPermisos = (token: string, values: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...values }),
    };

    fetch(apiUrl + "/puesto/permiso/agregar", requestOptions)
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al agregar permisos: ", err);
        reject(err);
      });
  });
};
